import { EventEmitter, Injectable } from '@angular/core';
import { ResourceDto } from '../_dtos/resourceResDto';

@Injectable({
  providedIn: 'root',
})
export class TableDataService {
  resourceUpdated = new EventEmitter<{
    id: string;
    changes: Partial<ResourceDto>;
  }>();
  resourceDeleted = new EventEmitter<string>();

  constructor() {}

  notifyResourceUpdate(id: string, changes: Partial<ResourceDto>) {
    this.resourceUpdated.emit({ id, changes });
  }

  notifyResourceDelete(id: string) {
    this.resourceDeleted.emit(id);
  }
}
